<div fxLayout="column">
    <div fxFlex="1 1 auto" fxLayout="row">
        <app-search-bar searchContextName="TransactionSearch" [searchBarTermOptions]="searchBarTermOptions" [placeholder]="'Transaction Search'"
            fxFlex="1 1 auto"></app-search-bar>
        <button mat-fab (click)="search()">
            <mat-icon>search</mat-icon>
        </button>
    </div>
    <app-transaction-table fxFlex="1 1 auto" [transactionDetailResult]="transactionDetailResult" fxFlex="1 1 auto"></app-transaction-table>
</div>